var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.00008V8.42008C22 10.0001 21 11.0001 19.42 11.0001H16V4.01008C16 2.90008 16.91 1.99008 18.02 2.00008C19.11 2.01008 20.11 2.45008 20.83 3.17008C21.55 3.90008 22 4.90008 22 6.00008Z",
    fill: "#002E64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2 7V21C2 21.83 2.94 22.3 3.6 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.29 22.29C8.68 22.68 9.32 22.68 9.71 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7H6C3 2 2 3.79 2 6V7Z",
    fill: "#002E64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.26H9C8.59 12.26 8.25 12.6 8.25 13.01C8.25 13.42 8.59 13.76 9 13.76H12C12.41 13.76 12.75 13.42 12.75 13.01C12.75 12.6 12.41 12.26 12 12.26Z",
    fill: "#002E64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.76001H12C12.41 9.76001 12.75 9.42001 12.75 9.01001C12.75 8.60001 12.41 8.26001 12 8.26001H9C8.59 8.26001 8.25 8.60001 8.25 9.01001C8.25 9.42001 8.59 9.76001 9 9.76001Z",
    fill: "#002E64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9707 8.01001C5.4107 8.01001 4.9707 8.46001 4.9707 9.01001C4.9707 9.56001 5.4207 10.01 5.9707 10.01C6.5207 10.01 6.9707 9.56001 6.9707 9.01001C6.9707 8.46001 6.5207 8.01001 5.9707 8.01001Z",
    fill: "#002E64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9707 12.01C5.4107 12.01 4.9707 12.46 4.9707 13.01C4.9707 13.56 5.4207 14.01 5.9707 14.01C6.5207 14.01 6.9707 13.56 6.9707 13.01C6.9707 12.46 6.5207 12.01 5.9707 12.01Z",
    fill: "#002E64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.0bc476ac452a586e48b1d5dd5d383e42.svg";
export { ForwardRef as ReactComponent };